import { useEffect, useState } from "react";
import AppRouter from "./routes/AppRouter";

export default function App() {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

  useEffect(() => {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
    localStorage.setItem("theme", theme);
  }, [theme]);

  return <AppRouter theme={theme} setTheme={setTheme} />;
}
